var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSize } from "@react-md/utils";
import { Menu } from "./Menu";
import { MenuConfigurationProvider, useMenuConfiguration, } from "./MenuConfigurationProvider";
import { MenuSheet } from "./MenuSheet";
/**
 * This component conditionally renders either the `Menu` or `MenuSheet`
 * component based on the current menu configuration.
 *
 * @internal
 * @remarks \@since 5.0.0
 */
export function MenuRenderer(_a) {
    var menuRef = _a.menuRef, menuProps = _a.menuProps, menuStyle = _a.menuStyle, menuClassName = _a.menuClassName, sheetProps = _a.sheetProps, propSheetHeader = _a.sheetHeader, propSheetFooter = _a.sheetFooter, sheetStyle = _a.sheetStyle, sheetClassName = _a.sheetClassName, sheetMenuProps = _a.sheetMenuProps, children = _a.children, propHorizontal = _a.horizontal, propRenderAsSheet = _a.renderAsSheet, propSheetPosition = _a.sheetPosition, propSheetVerticalSize = _a.sheetVerticalSize, onRequestClose = _a.onRequestClose, onClick = _a.onClick, onKeyDown = _a.onKeyDown, props = __rest(_a, ["menuRef", "menuProps", "menuStyle", "menuClassName", "sheetProps", "sheetHeader", "sheetFooter", "sheetStyle", "sheetClassName", "sheetMenuProps", "children", "horizontal", "renderAsSheet", "sheetPosition", "sheetVerticalSize", "onRequestClose", "onClick", "onKeyDown"]);
    var isPhone = useAppSize().isPhone;
    var _b = useMenuConfiguration({
        horizontal: propHorizontal,
        renderAsSheet: propRenderAsSheet,
        sheetHeader: propSheetHeader,
        sheetFooter: propSheetFooter,
        sheetPosition: propSheetPosition,
        sheetVerticalSize: propSheetVerticalSize,
    }), horizontal = _b.horizontal, renderAsSheet = _b.renderAsSheet, sheetHeader = _b.sheetHeader, sheetFooter = _b.sheetFooter, sheetPosition = _b.sheetPosition, sheetVerticalSize = _b.sheetVerticalSize;
    var handlers = {
        onClick: onClick,
        onKeyDown: onKeyDown,
    };
    var sheet = renderAsSheet === true || (renderAsSheet === "phone" && isPhone);
    return (_jsxs(MenuConfigurationProvider, __assign({ horizontal: horizontal, renderAsSheet: renderAsSheet, sheetHeader: sheetHeader, sheetFooter: sheetFooter, sheetPosition: sheetPosition, sheetVerticalSize: sheetVerticalSize }, { children: [!sheet && (_jsx(Menu, __assign({}, props, menuProps, handlers, { ref: menuRef, style: menuStyle, className: menuClassName, horizontal: horizontal }, { children: children }))), sheet && (_jsx(MenuSheet, __assign({}, props, sheetProps, { style: sheetStyle, className: sheetClassName, horizontal: horizontal, onRequestClose: onRequestClose, header: sheetHeader, footer: sheetFooter, menuRef: menuRef, menuProps: __assign(__assign({}, sheetMenuProps), handlers), position: sheetPosition, verticalSize: sheetVerticalSize }, { children: children })))] })));
}
//# sourceMappingURL=MenuRenderer.js.map